// THIS FILE GENERATED BY WEBPACK. DO NOT EDIT THIS FILE DIRECTLY.
import AboutUsDefaultV2 from "./about-us/default-v2";
import BannerSectionBazaar from "./banner-section/bazaar";
import BannerSectionDefault from "./banner-section/default";
import BannerSectionFootmart from "./banner-section/footmart";
import BannerWrapperCutoutImg from "./banner-wrapper/cutout-img";
import BannerWrapperDathacons from "./banner-wrapper/dathacons";
import BannerWrapperDefault from "./banner-wrapper/default";
import BannerWrapperGoogleMap from "./banner-wrapper/google-map";
import BannerWrapperMarquee from "./banner-wrapper/marquee";
import BannerWrapperYoutube from "./banner-wrapper/youtube";
import BlogWrapperDefault from "./blog-wrapper/default";
import BlogWrapperMasonry from "./blog-wrapper/masonry";
import BrandingShowcaseDefault from "./branding-showcase/default";
import ButtonDefault from "./button/default";
import ButtonOutlined from "./button/outlined";
import ButtonText from "./button/text";
import CallActionDefault from "./call-action/default";
import CardGridDefaultV2 from "./card-grid/default-v2";
import CartSectionBazaar from "./cart-section/bazaar";
import CartSectionDefault from "./cart-section/default";
import CartSectionFootmart from "./cart-section/footmart";
import CategoryItemBazaar from "./category-item/bazaar";
import CategoryItemDefault from "./category-item/default";
import CategoryItemHorizontal from "./category-item/horizontal";
import CategoryItemVertical from "./category-item/vertical";
import CategoryListSectionBazaarFlashSale from "./category-list-section/bazaar-flash-sale";
import CategoryListSectionBazaarGrid from "./category-list-section/bazaar-grid";
import CategoryListSectionBazaar from "./category-list-section/bazaar";
import CategoryListSectionFootmart from "./category-list-section/footmart";
import CategorySectionBazaar from "./category-section/bazaar";
import CategorySectionFootmart from "./category-section/footmart";
import CheckoutCardAddress from "./checkout-card/address";
import CheckoutCardBill from "./checkout-card/bill";
import CheckoutCardDefault from "./checkout-card/default";
import CollectionSectionBazaar from "./collection-section/bazaar";
import CollectionSectionDefault from "./collection-section/default";
import CollectionSectionFootmart from "./collection-section/footmart";
import ContactFormDefaultV2 from "./contact-form/default-v2";
import ContainerWrapperDefault from "./container-wrapper/default";
import CtaDefaultV2 from "./cta/default-v2";
import CustomerDashboardSectionBazaar from "./customer-dashboard-section/bazaar";
import CustomerDashboardSectionDefault from "./customer-dashboard-section/default";
import CustomerDashboardSectionFootmart from "./customer-dashboard-section/footmart";
import DividerDefault from "./divider/default";
import DsBlogCardDefaultV2 from "./ds-blog-card/default-v2";
import DynamicCardDefault from "./dynamic-card/default";
import DynamicCardHaianh from "./dynamic-card/haianh";
import DynamicCardNovaPress from "./dynamic-card/nova-press";
import EditorEditorMenuControls from "./editor/EditorMenuControls";
import EditorRichContentRenderer from "./editor/RichContentRenderer";
import EditorDefaultV2 from "./editor/default-v2";
import EditorIndex from "./editor/index";
import FeatureCardDefault from "./feature-card/default";
import FeaturedProjectsDathacons from "./featured-projects/dathacons";
import FileUploadIndex from "./file-upload/index";
import FixedProductCategoryDefaultV2 from "./fixed-product-category/default-v2";
import FlipClockCountdownDefault from "./flip-clock-countdown/default";
import FooterBazaar from "./footer/bazaar";
import FooterDathacons from "./footer/dathacons";
import FooterDefaultV2 from "./footer/default-v2";
import FooterDefault from "./footer/default";
import FooterFootmart from "./footer/footmart";
import FooterHaianh from "./footer/haianh";
import FooterLuxe from "./footer/luxe";
import FooterSimple from "./footer/simple";
import FormWrapperDefault from "./form-wrapper/default";
import GalleryWrapperDefault from "./gallery-wrapper/default";
import GridWrapperDefault from "./grid-wrapper/default";
import HeaderBazaar from "./header/bazaar";
import HeaderDathacons from "./header/dathacons";
import HeaderDefaultV2 from "./header/default-v2";
import HeaderDefault from "./header/default";
import HeaderFootmart from "./header/footmart";
import HeaderHaianh from "./header/haianh";
import HeaderLoginButton from "./header/login-button";
import HeaderNovaPress from "./header/nova-press";
import HeaderSearchResultCard from "./header/search-result-card";
import HeaderSearchResult from "./header/search-result";
import HeroBannerDefaultV2 from "./hero-banner/default-v2";
import HeroImageDefault from "./hero-image/default";
import IconDefault from "./icon/default";
import LinkSalifyLink from "./link/salify-link";
import MarkdownDefault from "./markdown/default";
import MarqueeDefaultV2 from "./marquee/default-v2";
import OrderConfirmationSectionBazaar from "./order-confirmation-section/bazaar";
import OrderConfirmationSectionFootmart from "./order-confirmation-section/footmart";
import PageBannerDefault from "./page-banner/default";
import PageBannerHaianh from "./page-banner/haianh";
import PageBannerLuxe from "./page-banner/luxe";
import PageWithStickySideNavbarDefault from "./page-with-sticky-side-navbar/default";
import PetProductsGridDefault from "./pet-products-grid/default";
import PetProductsGridHaianh from "./pet-products-grid/haianh";
import ProductDetailsBazaar from "./product-details/bazaar";
import ProductDetailsDefault from "./product-details/default";
import ProductDetailsFootmart from "./product-details/footmart";
import ProductItemBazaar from "./product-item/bazaar";
import ProductItemDefault from "./product-item/default";
import ProductItemHorizontal from "./product-item/horizontal";
import ProductItemVertical from "./product-item/vertical";
import ProductListSectionBazaarFlashSale from "./product-list-section/bazaar-flash-sale";
import ProductListSectionBazaarGrid from "./product-list-section/bazaar-grid";
import ProductListSectionBazaar from "./product-list-section/bazaar";
import ProductListSectionDefaultFlashSale from "./product-list-section/default-flash-sale";
import ProductListSectionDefaultFullwidth from "./product-list-section/default-fullwidth";
import ProductListSectionDefaultGrid from "./product-list-section/default-grid";
import ProductListSectionDefault from "./product-list-section/default";
import ProductListSectionFootmartFlashSale from "./product-list-section/footmart-flash-sale";
import ProductListSectionFootmartGrid from "./product-list-section/footmart-grid";
import ProductListSectionFootmart from "./product-list-section/footmart";
import ProductListSectionHaianhFullwidth from "./product-list-section/haianh-fullwidth";
import ProductListSectionLuxe from "./product-list-section/luxe";
import PromoBannerLuxe from "./promo-banner/luxe";
import SalifyNextLayoutBazaar from "./salify-next-layout/bazaar";
import SalifyNextLayoutDefault from "./salify-next-layout/default";
import SalifyNextLayoutFootmart from "./salify-next-layout/footmart";
import SalifyNextPagesAppDefault from "./salify-next-pages-app/default";
import SalifyNextPagesDocumentDefault from "./salify-next-pages-document/default";
import SectionWrapperDathacons from "./section-wrapper/dathacons";
import SectionWrapperDefault from "./section-wrapper/default";
import SelectFieldDefault from "./select-field/default";
import SeoRenderDefault from "./seo-render/default";
import ServiceIconDefault from "./service-icon/default";
import ServicesSectionDathaconsExpertise from "./services-section/dathacons-expertise";
import ServicesSectionDathacons from "./services-section/dathacons";
import StackWrapperDefault from "./stack-wrapper/default";
import SwiperWrapperDathaconsMarqueeIcons from "./swiper-wrapper/dathacons-marquee-icons";
import SwiperWrapperDathaconsMarqueeSvgIcons from "./swiper-wrapper/dathacons-marquee-svg-icons";
import SwiperWrapperDathaconsMarquee from "./swiper-wrapper/dathacons-marquee";
import SwiperWrapperDefault from "./swiper-wrapper/default";
import TestimonialGridLuxe from "./testimonial-grid/luxe";
import TextFieldDefault from "./text-field/default";
import TextFieldHidden from "./text-field/hidden";
import TextFieldMultiline from "./text-field/multiline";
import TextFieldPhone from "./text-field/phone";
import TopBarDefaultV2 from "./top-bar/default-v2";
import TopBarDefault from "./top-bar/default";
import TopBarIconTopBar from "./top-bar/icon-top-bar";
import TypographyDefault from "./typography/default";
import TypographyWrapperDefault from "./typography-wrapper/default";
import ValuePropsRowLuxe from "./value-props-row/luxe";

export const components = {
  ["about-us"]: {
    ["default-v2"]: AboutUsDefaultV2,
  },
  ["banner-section"]: {
    ["bazaar"]: BannerSectionBazaar,
    ["default"]: BannerSectionDefault,
    ["footmart"]: BannerSectionFootmart,
  },
  ["banner-wrapper"]: {
    ["cutout-img"]: BannerWrapperCutoutImg,
    ["dathacons"]: BannerWrapperDathacons,
    ["default"]: BannerWrapperDefault,
    ["google-map"]: BannerWrapperGoogleMap,
    ["marquee"]: BannerWrapperMarquee,
    ["youtube"]: BannerWrapperYoutube,
  },
  ["blog-wrapper"]: {
    ["default"]: BlogWrapperDefault,
    ["masonry"]: BlogWrapperMasonry,
  },
  ["branding-showcase"]: {
    ["default"]: BrandingShowcaseDefault,
  },
  ["button"]: {
    ["default"]: ButtonDefault,
    ["outlined"]: ButtonOutlined,
    ["text"]: ButtonText,
  },
  ["call-action"]: {
    ["default"]: CallActionDefault,
  },
  ["card-grid"]: {
    ["default-v2"]: CardGridDefaultV2,
  },
  ["cart-section"]: {
    ["bazaar"]: CartSectionBazaar,
    ["default"]: CartSectionDefault,
    ["footmart"]: CartSectionFootmart,
  },
  ["category-item"]: {
    ["bazaar"]: CategoryItemBazaar,
    ["default"]: CategoryItemDefault,
    ["horizontal"]: CategoryItemHorizontal,
    ["vertical"]: CategoryItemVertical,
  },
  ["category-list-section"]: {
    ["bazaar-flash-sale"]: CategoryListSectionBazaarFlashSale,
    ["bazaar-grid"]: CategoryListSectionBazaarGrid,
    ["bazaar"]: CategoryListSectionBazaar,
    ["footmart"]: CategoryListSectionFootmart,
  },
  ["category-section"]: {
    ["bazaar"]: CategorySectionBazaar,
    ["footmart"]: CategorySectionFootmart,
  },
  ["checkout-card"]: {
    ["address"]: CheckoutCardAddress,
    ["bill"]: CheckoutCardBill,
    ["default"]: CheckoutCardDefault,
  },
  ["collection-section"]: {
    ["bazaar"]: CollectionSectionBazaar,
    ["default"]: CollectionSectionDefault,
    ["footmart"]: CollectionSectionFootmart,
  },
  ["contact-form"]: {
    ["default-v2"]: ContactFormDefaultV2,
  },
  ["container-wrapper"]: {
    ["default"]: ContainerWrapperDefault,
  },
  ["cta"]: {
    ["default-v2"]: CtaDefaultV2,
  },
  ["customer-dashboard-section"]: {
    ["bazaar"]: CustomerDashboardSectionBazaar,
    ["default"]: CustomerDashboardSectionDefault,
    ["footmart"]: CustomerDashboardSectionFootmart,
  },
  ["divider"]: {
    ["default"]: DividerDefault,
  },
  ["ds-blog-card"]: {
    ["default-v2"]: DsBlogCardDefaultV2,
  },
  ["dynamic-card"]: {
    ["default"]: DynamicCardDefault,
    ["haianh"]: DynamicCardHaianh,
    ["nova-press"]: DynamicCardNovaPress,
  },
  ["editor"]: {
    ["EditorMenuControls"]: EditorEditorMenuControls,
    ["RichContentRenderer"]: EditorRichContentRenderer,
    ["default-v2"]: EditorDefaultV2,
    ["index"]: EditorIndex,
  },
  ["feature-card"]: {
    ["default"]: FeatureCardDefault,
  },
  ["featured-projects"]: {
    ["dathacons"]: FeaturedProjectsDathacons,
  },
  ["file-upload"]: {
    ["index"]: FileUploadIndex,
  },
  ["fixed-product-category"]: {
    ["default-v2"]: FixedProductCategoryDefaultV2,
  },
  ["flip-clock-countdown"]: {
    ["default"]: FlipClockCountdownDefault,
  },
  ["footer"]: {
    ["bazaar"]: FooterBazaar,
    ["dathacons"]: FooterDathacons,
    ["default-v2"]: FooterDefaultV2,
    ["default"]: FooterDefault,
    ["footmart"]: FooterFootmart,
    ["haianh"]: FooterHaianh,
    ["luxe"]: FooterLuxe,
    ["simple"]: FooterSimple,
  },
  ["form-wrapper"]: {
    ["default"]: FormWrapperDefault,
  },
  ["gallery-wrapper"]: {
    ["default"]: GalleryWrapperDefault,
  },
  ["grid-wrapper"]: {
    ["default"]: GridWrapperDefault,
  },
  ["header"]: {
    ["bazaar"]: HeaderBazaar,
    ["dathacons"]: HeaderDathacons,
    ["default-v2"]: HeaderDefaultV2,
    ["default"]: HeaderDefault,
    ["footmart"]: HeaderFootmart,
    ["haianh"]: HeaderHaianh,
    ["login-button"]: HeaderLoginButton,
    ["nova-press"]: HeaderNovaPress,
    ["search-result-card"]: HeaderSearchResultCard,
    ["search-result"]: HeaderSearchResult,
  },
  ["hero-banner"]: {
    ["default-v2"]: HeroBannerDefaultV2,
  },
  ["hero-image"]: {
    ["default"]: HeroImageDefault,
  },
  ["icon"]: {
    ["default"]: IconDefault,
  },
  ["link"]: {
    ["salify-link"]: LinkSalifyLink,
  },
  ["markdown"]: {
    ["default"]: MarkdownDefault,
  },
  ["marquee"]: {
    ["default-v2"]: MarqueeDefaultV2,
  },
  ["order-confirmation-section"]: {
    ["bazaar"]: OrderConfirmationSectionBazaar,
    ["footmart"]: OrderConfirmationSectionFootmart,
  },
  ["page-banner"]: {
    ["default"]: PageBannerDefault,
    ["haianh"]: PageBannerHaianh,
    ["luxe"]: PageBannerLuxe,
  },
  ["page-with-sticky-side-navbar"]: {
    ["default"]: PageWithStickySideNavbarDefault,
  },
  ["pet-products-grid"]: {
    ["default"]: PetProductsGridDefault,
    ["haianh"]: PetProductsGridHaianh,
  },
  ["product-details"]: {
    ["bazaar"]: ProductDetailsBazaar,
    ["default"]: ProductDetailsDefault,
    ["footmart"]: ProductDetailsFootmart,
  },
  ["product-item"]: {
    ["bazaar"]: ProductItemBazaar,
    ["default"]: ProductItemDefault,
    ["horizontal"]: ProductItemHorizontal,
    ["vertical"]: ProductItemVertical,
  },
  ["product-list-section"]: {
    ["bazaar-flash-sale"]: ProductListSectionBazaarFlashSale,
    ["bazaar-grid"]: ProductListSectionBazaarGrid,
    ["bazaar"]: ProductListSectionBazaar,
    ["default-flash-sale"]: ProductListSectionDefaultFlashSale,
    ["default-fullwidth"]: ProductListSectionDefaultFullwidth,
    ["default-grid"]: ProductListSectionDefaultGrid,
    ["default"]: ProductListSectionDefault,
    ["footmart-flash-sale"]: ProductListSectionFootmartFlashSale,
    ["footmart-grid"]: ProductListSectionFootmartGrid,
    ["footmart"]: ProductListSectionFootmart,
    ["haianh-fullwidth"]: ProductListSectionHaianhFullwidth,
    ["luxe"]: ProductListSectionLuxe,
  },
  ["promo-banner"]: {
    ["luxe"]: PromoBannerLuxe,
  },
  ["salify-next-layout"]: {
    ["bazaar"]: SalifyNextLayoutBazaar,
    ["default"]: SalifyNextLayoutDefault,
    ["footmart"]: SalifyNextLayoutFootmart,
  },
  ["salify-next-pages-app"]: {
    ["default"]: SalifyNextPagesAppDefault,
  },
  ["salify-next-pages-document"]: {
    ["default"]: SalifyNextPagesDocumentDefault,
  },
  ["section-wrapper"]: {
    ["dathacons"]: SectionWrapperDathacons,
    ["default"]: SectionWrapperDefault,
  },
  ["select-field"]: {
    ["default"]: SelectFieldDefault,
  },
  ["seo-render"]: {
    ["default"]: SeoRenderDefault,
  },
  ["service-icon"]: {
    ["default"]: ServiceIconDefault,
  },
  ["services-section"]: {
    ["dathacons-expertise"]: ServicesSectionDathaconsExpertise,
    ["dathacons"]: ServicesSectionDathacons,
  },
  ["stack-wrapper"]: {
    ["default"]: StackWrapperDefault,
  },
  ["swiper-wrapper"]: {
    ["dathacons-marquee-icons"]: SwiperWrapperDathaconsMarqueeIcons,
    ["dathacons-marquee-svg-icons"]: SwiperWrapperDathaconsMarqueeSvgIcons,
    ["dathacons-marquee"]: SwiperWrapperDathaconsMarquee,
    ["default"]: SwiperWrapperDefault,
  },
  ["testimonial-grid"]: {
    ["luxe"]: TestimonialGridLuxe,
  },
  ["text-field"]: {
    ["default"]: TextFieldDefault,
    ["hidden"]: TextFieldHidden,
    ["multiline"]: TextFieldMultiline,
    ["phone"]: TextFieldPhone,
  },
  ["top-bar"]: {
    ["default-v2"]: TopBarDefaultV2,
    ["default"]: TopBarDefault,
    ["icon-top-bar"]: TopBarIconTopBar,
  },
  ["typography"]: {
    ["default"]: TypographyDefault,
  },
  ["typography-wrapper"]: {
    ["default"]: TypographyWrapperDefault,
  },
  ["value-props-row"]: {
    ["luxe"]: ValuePropsRowLuxe,
  },
};

export default components;
